import React from 'react';

import { Box, BoxProps, SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

export interface ImageProps {
  sx?: SxProps<Theme>;
  testId?: string;
  src: string;
  alt?: string;
}

export const Image = ({ testId, src, sx, alt = 'no img' }: BoxProps & ImageProps) => {
  return <Box component="img" data-testid={testId} src={src} alt={alt} sx={sx} />;
};
